import { usePageMeta } from "@/lib/seo";
import { Link } from "react-router-dom";

const PORTRAIT =
  "/images/hero.jpg";

export default function About() {
  usePageMeta(
    "About Mehjabin — The Story Behind Just be you",
    "Meet Mehjabin — manifestation coach, tarot reader and the heart behind Just be you. Held with care across India, UAE & beyond."
  );
  return (
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24 relative" data-testid="about-page">
      <div className="absolute top-20 right-10 w-96 h-96 bg-peach/40 organic-blob blur-3xl -z-0 pointer-events-none" />

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start relative">
        <div className="lg:col-span-5 relative">
          <div className="absolute -inset-4 bg-sage/30 organic-blob blur-2xl -z-0" />
          <div className="relative aspect-[3/4] overflow-hidden rounded-[2rem] shadow-2xl shadow-lapis/15">
            <img
              src={PORTRAIT}
              alt="Mehjabin"
              className="absolute inset-0 w-full h-full object-cover"
              style={{ objectPosition: "center top", transform: "scale(1.18)", transformOrigin: "center top" }}
              data-testid="about-portrait"
            />
          </div>
        </div>

        <div className="lg:col-span-7 lg:pt-8">
          <div className="overline mb-5">About</div>
          <h1 className="font-serif text-5xl md:text-6xl text-lapis font-light leading-tight">
            I'm <em className="text-peach-deep">Mehjabin</em>.<br />And I hold soft rooms.
          </h1>

          <div className="mt-10 space-y-6 text-ink/75 leading-relaxed text-lg">
            <p>For most of my life I searched for a place where I could arrive without editing first. I didn't find it — so, slowly, I built it.</p>
            <p>
              <em className="text-ink font-serif">Just be you</em> is that room, opened outward. It's the small, hand-poured practice I lean on every day —
              meditations, writings, slow conversations, and rituals that help me return to myself when the noise gets loud.
            </p>
            <p>
              Whether you've come here for an e-book, a sitting, or simply to feel less alone — you are welcome. Exactly as you are. With whatever you are holding.
            </p>
            <p className="font-serif italic text-ink text-xl">You don't have to be anyone for this space. Just be you.</p>
          </div>

          <div className="mt-12 flex flex-col sm:flex-row gap-4">
            <Link to="/bookings" className="btn-primary" data-testid="about-book-btn">Sit with me</Link>
            <Link to="/library" className="btn-soft" data-testid="about-library-btn">Read · listen · watch</Link>
          </div>
        </div>
      </div>

      <div className="divider-soft my-24" />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-center relative">
        {[{ n: "4yrs", l: "Holding space" }, { n: "1:1", l: "Heart-led sittings" }, { n: "∞", l: "Tea steeped" }].map((s) => (
          <div key={s.l}>
            <div className="font-serif text-5xl text-peach-deep">{s.n}</div>
            <div className="overline mt-3">{s.l}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
